const API_CONFIG = {
  development: {
    BASE_URL: process.env.REACT_APP_API_URL || "https://printformee.com/api",
  },
  production: {
    BASE_URL: process.env.REACT_APP_API_URL || "https://printformee.com/api",
  },
};

const getApiConfig = () => {
  // Use environment variable if available, otherwise default based on NODE_ENV
  if (process.env.REACT_APP_API_URL) {
    return {
      BASE_URL: process.env.REACT_APP_API_URL,
    };
  }
  const environment = process.env.NODE_ENV || "development";
  return API_CONFIG[environment];
};

export const API_BASE_URL = getApiConfig().BASE_URL;

// Log API configuration for debugging
if (process.env.NODE_ENV !== "production") {
  console.log("🌐 API Configuration:", { BASE_URL: API_BASE_URL });
}
